import type { TextFontWeightModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import FontWeightSelector from "@agent-ui/features/modifiers/base/FontWeightSelector";
import { useSemanticModifierValue } from "@agent-ui/features/modifiers/hooks/useSemanticModifierValue";

interface FontWeightModifierProps {
  onChange: (modifiers: TextFontWeightModifierValue[]) => void;
}

const FontWeightModifierComponent: React.FC<FontWeightModifierProps> = ({
  onChange,
}) => {
  const currentValue =
    useSemanticModifierValue({
      semanticExtractor: ({ computedStyles }) => {
        const weight = computedStyles.fontWeight;
        if (!weight) {
          return null;
        }
        const num = Number.parseInt(weight, 10);
        return isNaN(num) ? null : num;
      },
    }) ?? null;

  const fontFamily =
    useSemanticModifierValue({
      semanticExtractor: ({ computedStyles }) => {
        return computedStyles.fontFamily || null;
      },
    }) ?? null;

  const handleValueChange = (weight: number | null) => {
    if (weight) {
      onChange([
        {
          type: "fontWeight" as const,
          value: weight,
        },
      ]);
    }
  };

  return (
    <div className="font-weight-modifier">
      <FontWeightSelector
        fontWeight={currentValue}
        onSelect={handleValueChange}
        placeholder="Select weight"
        fontFamily={fontFamily}
      />
    </div>
  );
};

export default FontWeightModifierComponent;
